<script>

/**
 * Vue: Physical links (physical-links)
 * -----------------------------------------------------------------------------
 * Physical Links.
 *
 */
export default {
  name: 'PhysicalLinks',

  data() {
    return {
      cnvsStatic: true,
    }
  },
}
</script>

<style lang="scss">
@import './physical-links';
</style>
